// These cannot be changed due to how the cx widget form is set
export default {
  firstName: 'firstname',
  lastName: 'lastname',
  emailAddress: 'email',
  phoneNumber: 'phonenumber',
  subject: 'subject',
};
